let refreshPromise = null;
let isRedirecting = false;

export async function apiFetch(url, options = {}) {
    // skipAuthRefresh is our own flag - pull it out so it isn't passed to fetch().
    const { skipAuthRefresh = false, headers, ...rest } = options;

    const method = (rest.method || "GET").toUpperCase();
    let requestUrl = url;

    // FIX (Capacitor iOS): make every GET URL unique so neither WKWebView nor
    // the native CapacitorHttp layer can hand back an old cached response.
    // The backend ignores ?_ts= in its own cache key, so this costs nothing there.
    if (method === "GET") {
        requestUrl += (requestUrl.includes("?") ? "&" : "?") + "_ts=" + Date.now();
    }

    const config = {
        credentials: "include", // REQUIRED for cookie JWT
        cache: "no-store",      // FIX: never reuse a cached API response
        ...rest,
        // FIX: headers are merged LAST. Previously `...options` came after
        // this, so passing any headers replaced the defaults entirely.
        headers: {
            "Content-Type": "application/json",
            ...(headers || {})
        }
    };

    let response = await fetch(requestUrl, config);

    // If unauthorized → try refresh
    if ((response.status === 401 || response.status === 422) && !skipAuthRefresh) {

        if (url.includes("/api/auth/me")) {
            return response;
        }

        // Prevent multiple refresh calls at once
        if (!refreshPromise) {
            refreshPromise = fetch("/api/auth/refresh", {
                method: "POST",
                credentials: "include",
                cache: "no-store"
            }).finally(() => {
                refreshPromise = null;
            });
        }

        const refreshResponse = await refreshPromise;

        if (!refreshResponse.ok) {
            if (!isRedirecting) {
                isRedirecting = true;
                window.location.href = "/login";
            }
            throw new Error("Session expired");
        }

        // Retry original request
        response = await fetch(requestUrl, config);
    }

    return response;
}

export async function apiFetchJSON(url, options = {}) {
    const response = await apiFetch(url, options);

    if (!response.ok) {
        let data = null;
        try {
            data = await response.json();
        } catch {}
        // Keep the status and the parsed body on the error so callers can read
        // extra details, e.g. { error, field: 'email' } for a duplicate email.
        const error = new Error((data && data.error) || "Request failed");
        error.status = response.status;
        error.data = data;
        throw error;
    }

    // Handle 204 properly
    if (response.status === 204) {
        return null;
    }

    return response.json();
}
